'use client'

import BookingDetailsIcon from '@/assets/icons/booking-details.svg'
import SettingsIcon from '@/assets/icons/settings.svg'
import TransferIcon from '@/assets/icons/transfer.svg'
import WalletIcon from '@/assets/icons/wallet.svg'
import { ROUTES } from '@/core/constants/routes'
import { Stepper } from '@/core/ui/components/stepper'
import { usePathname } from '@/i18n/navigation'
import { useTranslations } from 'next-intl'

const useTripDetails = () => {
  const pathname = usePathname()
  const segments = pathname.split('/').slice(2)
  let paymentStatus = 'pending'
  let step = 0

  if (segments.length === 1) {
    return { step, payment: paymentStatus, tripId: null }
  }

  const [tripId, _, subpath] = segments
  if (subpath === 'booking-details') {
    step = 1
  }
  if (subpath === 'pay') {
    step = 2
  }

  if (subpath === 'payemnt-failed') {
    step = 3
    paymentStatus = 'failed'
  }
  if (subpath === 'payment-succeed') {
    step = 3
    paymentStatus = 'success'
  }
  return {
    step,
    payment: paymentStatus,
    tripId,
  }
}

export const UpdateTripStepper = () => {
  const t = useTranslations()
  const { payment, step, tripId } = useTripDetails()

  if (!tripId) {
    return null
  }
  const steps = [
    {
      label: t('trip.prepareTitle'),
      icon: <SettingsIcon />,
      link: ROUTES.updateTrip(tripId),
    },
    {
      label: t('trip.detailsTitle'),
      icon: <BookingDetailsIcon />,
      link: ROUTES.updateTripBookingDetails(tripId),
    },
    {
      label: t('trip.transferTitle'),
      icon: <TransferIcon />,
      link: ROUTES.updateTripPay(tripId),
    },
    {
      label: t('trip.paymentTitle'),
      icon:
        payment === 'failed' ? (
          <div className='border-red bg-red z-10 flex h-full w-full items-center justify-center rounded-full border p-5 text-2xl text-white'>
            &#x2715;
          </div>
        ) : (
          <WalletIcon />
        ),
      link:
        payment === 'failed'
          ? ROUTES.updateTripPaymentFailed(tripId)
          : ROUTES.updateTripPaymentSucceed(tripId),
    },
  ]
  return <Stepper activeStep={step} steps={steps} canBack={step < 2} />
}
